import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {List} from '@mui/material';
import {EarlyFeature} from 'app/components/earlyFeatureAccess/EarlyFeature';

const EarlyFeatureAccessOptInDialog = ({onClose, open, earlyAccessFeatures}) => {
  const features = earlyAccessFeatures;

  const handleClose = () => {
    onClose();
  };

  const EarlyAccessFeatureItem = features.map(feature => {
    return <EarlyFeature key={feature.slug} feature={feature} />;
  });

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'>
      <DialogTitle id='alert-dialog-title'>{'Neue Funktionen als Erster ausprobieren ✨'}</DialogTitle>
      <DialogContent>
        <DialogContentText>Die Einstellung wird nur für das aktuelle Gerät übernommen.</DialogContentText>
        <List>{EarlyAccessFeatureItem}</List>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Schließen</Button>
      </DialogActions>
    </Dialog>
  );
};

export {EarlyFeatureAccessOptInDialog};
